import 'babel-polyfill';
import 'custom-event-polyfill';
import 'document-register-element';
import { msalInstance, runWithMsal,logoutOnInactivity } from './webcommon/common/httpConnection/adfsConnection';

import queryString from 'query-string';
import './index.scss';
import 'react-dates/initialize';
import moment from 'moment';
import { usageHasBeenAgreedToday } from './common/helpermethods/HelperMethods';
import * as appConstants from './common/constants';

if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

const DO_NOT_LOGIN = false;
const useageAgreedDate = localStorage.getItem('BIOTIC/USAGE_AGREED');
if (!usageHasBeenAgreedToday(useageAgreedDate, moment().format(appConstants.dateFormat))) {
    // eslint-disable-next-line global-require
    require('./agreeUsage.jsx');
} else if (window.location.pathname.toLowerCase().endsWith('/loggedout')) {
    // eslint-disable-next-line global-require
    const logout = require('./logout.jsx').default;
    const params = queryString.parse(window.location.search);
    if (params.originalLocation) {
        const previousLocation = JSON.parse(atob(decodeURIComponent(params.originalLocation)));
        logout(previousLocation);
    } else {
        logout();
    }
} else {
    let loginTimeout = parseInt(window.APP_ENV_CONFIG.REACT_APP_AUTHENTICATION_TIMEOUT);
    if (Number.isNaN(loginTimeout)) {
        loginTimeout = 3600;
    }
    loginTimeout = Math.abs(loginTimeout);
    if (loginTimeout) {
        logoutOnInactivity(loginTimeout, '/loggedOut');
    }
    runWithMsal(msalInstance, () => {
        try {
            // eslint-disable-next-line global-require
            require('./index.jsx');
        } catch (error) {
            document.write(`
                An unhandled error has occured:<br/>
                ${error.toString()}<br/>
                Please try again
            `);
        }
    }, DO_NOT_LOGIN);
}
